import CropSquareIcon from "@mui/icons-material/CropSquare";
import TimelineIcon from "@mui/icons-material/Timeline";
import TripOriginIcon from "@mui/icons-material/TripOrigin";

const DEFAULT_COLOR = "#2563eb";

const ZONE_TYPE_CONFIG = {
  // Wialon zone types: 1 — line, 2 — polygon, 3 — circle.
  1: { Icon: TimelineIcon, color: DEFAULT_COLOR },
  2: { Icon: CropSquareIcon, color: DEFAULT_COLOR },
  3: { Icon: TripOriginIcon, color: DEFAULT_COLOR },
};

export const getZoneTypeVisual = (type) => {
  const numeric = typeof type === "number" ? type : Number(type);
  if (Number.isFinite(numeric) && ZONE_TYPE_CONFIG[numeric]) {
    return ZONE_TYPE_CONFIG[numeric];
  }
  return { Icon: TripOriginIcon, color: DEFAULT_COLOR };
};

export default getZoneTypeVisual;
